module.exports = __webpack_public_path__ + "static/media/text-logo.82d84cbd.svg";